export enum Permission {
  addon_strongbytes_playout_export = 'addon_strongbytes_playout_export',
  admin = 'admin',
  ai_access = 'ai_access',
  area_category_create = 'area_category_create',
  area_category_delete = 'area_category_delete',
  area_category_edit = 'area_category_edit',
  area_category_list = 'area_category_list',
  area_category_show = 'area_category_show',
  area_create = 'area_create',
  area_delete = 'area_delete',
  area_edit = 'area_edit',
  area_list = 'area_list',
  area_show = 'area_show',
  asset_category_create = 'asset_category_create',
  asset_category_delete = 'asset_category_delete',
  asset_category_edit = 'asset_category_edit',
  asset_category_list = 'asset_category_list',
  asset_category_show = 'asset_category_show',
  asset_create = 'asset_create',
  asset_delete = 'asset_delete',
  asset_edit = 'asset_edit',
  asset_edit_files = 'asset_edit_files',
  asset_export = 'asset_export',
  asset_list = 'asset_list',
  asset_repository_create = 'asset_repository_create',
  asset_repository_delete = 'asset_repository_delete',
  asset_repository_edit = 'asset_repository_edit',
  asset_repository_edit_assets = 'asset_repository_edit_assets',
  asset_repository_export = 'asset_repository_export',
  asset_repository_list = 'asset_repository_list',
  asset_repository_show = 'asset_repository_show',
  asset_show = 'asset_show',
  attachment_admin = 'attachment_admin',
  attachment_attach = 'attachment_attach',
  attachment_attach_to_area = 'attachment_attach_to_area',
  attachment_attach_to_campaign = 'attachment_attach_to_campaign',
  attachment_attach_to_channel = 'attachment_attach_to_channel',
  attachment_attach_to_company = 'attachment_attach_to_company',
  attachment_attach_to_deal = 'attachment_attach_to_deal',
  attachment_attach_to_device = 'attachment_attach_to_device',
  attachment_attach_to_discussion_post = 'attachment_attach_to_discussion_post',
  attachment_attach_to_discussion_topic = 'attachment_attach_to_discussion_topic',
  attachment_attach_to_location = 'attachment_attach_to_location',
  attachment_attach_to_player_hardware = 'attachment_attach_to_player_hardware',
  attachment_attach_to_player_software = 'attachment_attach_to_player_software',
  attachment_attach_to_product = 'attachment_attach_to_product',
  attachment_attach_to_screen_hardware = 'attachment_attach_to_screen_hardware',
  attachment_attach_to_ssp = 'attachment_attach_to_ssp',
  attachment_attach_to_ssp_contract = 'attachment_attach_to_ssp_contract',
  attachment_attach_to_visitor_tracker = 'attachment_attach_to_visitor_tracker',
  attachment_attaching = 'attachment_attaching',
  attachment_create = 'attachment_create',
  attachment_delete = 'attachment_delete',
  attachment_detach = 'attachment_detach',
  attachment_detach_from_area = 'attachment_detach_from_area',
  attachment_detach_from_campaign = 'attachment_detach_from_campaign',
  attachment_detach_from_channel = 'attachment_detach_from_channel',
  attachment_detach_from_company = 'attachment_detach_from_company',
  attachment_detach_from_deal = 'attachment_detach_from_deal',
  attachment_detach_from_device = 'attachment_detach_from_device',
  attachment_detach_from_discussion_post = 'attachment_detach_from_discussion_post',
  attachment_detach_from_discussion_topic = 'attachment_detach_from_discussion_topic',
  attachment_detach_from_location = 'attachment_detach_from_location',
  attachment_detach_from_player_hardware = 'attachment_detach_from_player_hardware',
  attachment_detach_from_player_software = 'attachment_detach_from_player_software',
  attachment_detach_from_product = 'attachment_detach_from_product',
  attachment_detach_from_screen_hardware = 'attachment_detach_from_screen_hardware',
  attachment_detach_from_ssp = 'attachment_detach_from_ssp',
  attachment_detach_from_ssp_contract = 'attachment_detach_from_ssp_contract',
  attachment_detach_from_visitor_tracker = 'attachment_detach_from_visitor_tracker',
  attachment_edit = 'attachment_edit',
  attachment_folder_create = 'attachment_folder_create',
  attachment_folder_delete = 'attachment_folder_delete',
  attachment_folder_edit = 'attachment_folder_edit',
  attachment_folder_list = 'attachment_folder_list',
  attachment_folder_show = 'attachment_folder_show',
  attachment_list = 'attachment_list',
  attachment_show = 'attachment_show',
  booking_list = 'booking_list',
  booking_show = 'booking_show',
  budget_create = 'budget_create',
  budget_delete = 'budget_delete',
  budget_edit = 'budget_edit',
  budget_list = 'budget_list',
  budget_planning_create = 'budget_planning_create',
  budget_planning_edit = 'budget_planning_edit',
  budget_show = 'budget_show',
  ca = 'ca',
  ca_am = 'ca_am',
  ca_md = 'ca_md',
  calendar_category_create = 'calendar_category_create',
  calendar_category_delete = 'calendar_category_delete',
  calendar_category_edit = 'calendar_category_edit',
  calendar_category_list = 'calendar_category_list',
  calendar_category_show = 'calendar_category_show',
  calendar_entry_attributes_edit = 'calendar_entry_attributes_edit',
  calendar_entry_attributes_show = 'calendar_entry_attributes_show',
  calendar_entry_category_create = 'calendar_entry_category_create',
  calendar_entry_category_delete = 'calendar_entry_category_delete',
  calendar_entry_category_edit = 'calendar_entry_category_edit',
  calendar_entry_category_list = 'calendar_entry_category_list',
  calendar_entry_category_show = 'calendar_entry_category_show',
  calendar_entry_meta_data_type_create = 'calendar_entry_meta_data_type_create',
  calendar_entry_meta_data_type_delete = 'calendar_entry_meta_data_type_delete',
  calendar_entry_meta_data_type_edit = 'calendar_entry_meta_data_type_edit',
  calendar_entry_meta_data_type_list = 'calendar_entry_meta_data_type_list',
  calendar_entry_meta_data_type_show = 'calendar_entry_meta_data_type_show',
  campaign_change_order = 'campaign_change_order',
  campaign_create = 'campaign_create',
  campaign_delete = 'campaign_delete',
  campaign_edit = 'campaign_edit',
  campaign_level_create = 'campaign_level_create',
  campaign_level_delete = 'campaign_level_delete',
  campaign_level_edit = 'campaign_level_edit',
  campaign_level_list = 'campaign_level_list',
  campaign_level_show = 'campaign_level_show',
  campaign_list = 'campaign_list',
  campaign_report = 'campaign_report',
  campaign_show = 'campaign_show',
  campaign_type_create = 'campaign_type_create',
  campaign_type_delete = 'campaign_type_delete',
  campaign_type_edit = 'campaign_type_edit',
  campaign_type_list = 'campaign_type_list',
  campaign_type_show = 'campaign_type_show',
  channel_change_order = 'channel_change_order',
  channel_create = 'channel_create',
  channel_delete = 'channel_delete',
  channel_edit = 'channel_edit',
  channel_list = 'channel_list',
  channel_lock = 'channel_lock',
  channel_show = 'channel_show',
  client_admin = 'client_admin',
  client_setting_delete = 'client_setting_delete',
  client_setting_edit = 'client_setting_edit',
  client_setting_list = 'client_setting_list',
  client_setting_show = 'client_setting_show',
  client_user_block = 'client_user_block',
  client_user_create = 'client_user_create',
  client_user_delete = 'client_user_delete',
  client_user_edit = 'client_user_edit',
  client_user_impersonate = 'client_user_impersonate',
  client_user_list = 'client_user_list',
  client_user_unblock = 'client_user_unblock',
  color_definition_create = 'color_definition_create',
  color_definition_delete = 'color_definition_delete',
  color_definition_edit = 'color_definition_edit',
  color_definition_list = 'color_definition_list',
  color_definition_show = 'color_definition_show',
  company_attribute_datatype_create = 'company_attribute_datatype_create',
  company_attribute_datatype_delete = 'company_attribute_datatype_delete',
  company_attribute_datatype_edit = 'company_attribute_datatype_edit',
  company_attribute_datatype_list = 'company_attribute_datatype_list',
  company_attribute_datatype_show = 'company_attribute_datatype_show',
  company_attributes_edit = 'company_attributes_edit',
  company_attributes_show = 'company_attributes_show',
  company_create = 'company_create',
  company_delete = 'company_delete',
  company_edit = 'company_edit',
  company_export = 'company_export',
  company_list = 'company_list',
  company_show = 'company_show',
  contact_create = 'contact_create',
  contact_delete = 'contact_delete',
  contact_edit = 'contact_edit',
  contact_list = 'contact_list',
  contact_show = 'contact_show',
  content_editor = 'content_editor',
  content_share_create = 'content_share_create',
  content_share_delete = 'content_share_delete',
  content_share_edit = 'content_share_edit',
  content_share_list = 'content_share_list',
  content_share_show = 'content_share_show',
  cron_definition_create = 'cron_definition_create',
  cron_definition_delete = 'cron_definition_delete',
  cron_definition_edit = 'cron_definition_edit',
  cron_definition_list = 'cron_definition_list',
  cron_definition_show = 'cron_definition_show',
  cs = 'cs',
  cull_category_create = 'cull_category_create',
  cull_category_delete = 'cull_category_delete',
  cull_category_edit = 'cull_category_edit',
  cull_category_list = 'cull_category_list',
  cull_category_show = 'cull_category_show',
  cull_client_create = 'cull_client_create',
  cull_client_delete = 'cull_client_delete',
  cull_client_edit = 'cull_client_edit',
  cull_content_create = 'cull_content_create',
  cull_content_delete = 'cull_content_delete',
  cull_content_edit = 'cull_content_edit',
  cull_create = 'cull_create',
  cull_delete = 'cull_delete',
  cull_edit = 'cull_edit',
  cull_geo_create = 'cull_geo_create',
  cull_geo_delete = 'cull_geo_delete',
  cull_geo_edit = 'cull_geo_edit',
  cull_hide = 'cull_hide',
  cull_list = 'cull_list',
  cull_lock = 'cull_lock',
  cull_lock_admin = 'cull_lock_admin',
  cull_player_create = 'cull_player_create',
  cull_player_delete = 'cull_player_delete',
  cull_player_edit = 'cull_player_edit',
  cull_show = 'cull_show',
  cull_state_space_create = 'cull_state_space_create',
  cull_state_space_delete = 'cull_state_space_delete',
  cull_state_space_edit = 'cull_state_space_edit',
  cull_time_create = 'cull_time_create',
  cull_time_delete = 'cull_time_delete',
  cull_time_edit = 'cull_time_edit',
  deal_create = 'deal_create',
  deal_delete = 'deal_delete',
  deal_edit = 'deal_edit',
  deal_list = 'deal_list',
  deal_show = 'deal_show',
  device_admin = 'device_admin',
  device_attribute_datatype_create = 'device_attribute_datatype_create',
  device_attribute_datatype_delete = 'device_attribute_datatype_delete',
  device_attribute_datatype_edit = 'device_attribute_datatype_edit',
  device_attribute_datatype_list = 'device_attribute_datatype_list',
  device_attribute_datatype_show = 'device_attribute_datatype_show',
  device_attributes_edit = 'device_attributes_edit',
  device_attributes_show = 'device_attributes_show',
  device_clear_local_data = 'device_clear_local_data',
  device_clear_local_settings = 'device_clear_local_settings',
  device_create = 'device_create',
  device_delete = 'device_delete',
  device_execute_remote_command = 'device_execute_remote_command',
  device_exit_player = 'device_exit_player',
  device_export = 'device_export',
  device_export_log = 'device_export_log',
  device_export_offline_playlist = 'device_export_offline_playlist',
  device_export_playout = 'device_export_playout',
  device_list = 'device_list',
  device_location_edit = 'device_location_edit',
  device_location_show = 'device_location_show',
  device_log = 'device_log',
  device_mass_action = 'device_mass_action',
  device_mass_edit = 'device_mass_edit',
  device_pair = 'device_pair',
  device_playlist_cache_delete = 'device_playlist_cache_delete',
  device_pool_edit = 'device_pool_edit',
  device_pool_show = 'device_pool_show',
  device_properties_edit = 'device_properties_edit',
  device_properties_show = 'device_properties_show',
  device_reboot = 'device_reboot',
  device_repair = 'device_repair',
  device_show = 'device_show',
  device_show_calibration_image = 'device_show_calibration_image',
  device_unpair = 'device_unpair',
  discussion_create = 'discussion_create',
  discussion_list = 'discussion_list',
  discussion_moderate = 'discussion_moderate',
  discussion_participate = 'discussion_participate',
  dm = 'dm',
  dm_geo = 'dm_geo',
  ds = 'ds',
  ds_cm = 'ds_cm',
  ds_cm_reporting = 'ds_cm_reporting',
  ds_rm = 'ds_rm',
  location_attribute_datatype_create = 'location_attribute_datatype_create',
  location_attribute_datatype_delete = 'location_attribute_datatype_delete',
  location_attribute_datatype_edit = 'location_attribute_datatype_edit',
  location_attribute_datatype_list = 'location_attribute_datatype_list',
  location_attribute_datatype_show = 'location_attribute_datatype_show',
  location_attributes_edit = 'location_attributes_edit',
  location_attributes_show = 'location_attributes_show',
  location_create = 'location_create',
  location_delete = 'location_delete',
  location_devices_show = 'location_devices_show',
  location_edit = 'location_edit',
  location_export = 'location_export',
  location_list = 'location_list',
  location_show = 'location_show',
  location_type_create = 'location_type_create',
  location_type_delete = 'location_type_delete',
  location_type_edit = 'location_type_edit',
  location_type_list = 'location_type_list',
  location_type_show = 'location_type_show',
  location_visitor_aggregation = 'location_visitor_aggregation',
  medium_create = 'medium_create',
  medium_delete = 'medium_delete',
  medium_edit = 'medium_edit',
  medium_group_add_promoted_products = 'medium_group_add_promoted_products',
  medium_group_attribute_datatype_create = 'medium_group_attribute_datatype_create',
  medium_group_attribute_datatype_delete = 'medium_group_attribute_datatype_delete',
  medium_group_attribute_datatype_edit = 'medium_group_attribute_datatype_edit',
  medium_group_attribute_datatype_list = 'medium_group_attribute_datatype_list',
  medium_group_attribute_datatype_show = 'medium_group_attribute_datatype_show',
  medium_group_attributes_edit = 'medium_group_attributes_edit',
  medium_group_attributes_show = 'medium_group_attributes_show',
  medium_group_category_create = 'medium_group_category_create',
  medium_group_category_delete = 'medium_group_category_delete',
  medium_group_category_edit = 'medium_group_category_edit',
  medium_group_category_list = 'medium_group_category_list',
  medium_group_category_show = 'medium_group_category_show',
  medium_group_create = 'medium_group_create',
  medium_group_delete = 'medium_group_delete',
  medium_group_edit = 'medium_group_edit',
  medium_group_list = 'medium_group_list',
  medium_group_manage_promoted_products = 'medium_group_manage_promoted_products',
  medium_group_remove_promoted_products = 'medium_group_remove_promoted_products',
  medium_group_show = 'medium_group_show',
  medium_list = 'medium_list',
  medium_lock = 'medium_lock',
  medium_show = 'medium_show',
  medium_transformation_list = 'medium_transformation_list',
  medium_transformation_show = 'medium_transformation_show',
  medium_upload = 'medium_upload',
  mi = 'mi',
  mm = 'mm',
  network_booking_list = 'network_booking_list',
  network_booking_show = 'network_booking_show',
  network_price_model_create = 'network_price_model_create',
  network_price_model_delete = 'network_price_model_delete',
  network_price_model_edit = 'network_price_model_edit',
  network_price_model_list = 'network_price_model_list',
  network_price_model_show = 'network_price_model_show',
  network_share_create = 'network_share_create',
  network_share_delete = 'network_share_delete',
  network_share_edit = 'network_share_edit',
  network_share_list = 'network_share_list',
  network_share_show = 'network_share_show',
  notification_archive = 'notification_archive',
  notification_list = 'notification_list',
  notification_read = 'notification_read',
  notification_show = 'notification_show',
  planning_accept = 'planning_accept',
  planning_change_order = 'planning_change_order',
  planning_create = 'planning_create',
  planning_delete = 'planning_delete',
  planning_edit = 'planning_edit',
  planning_list = 'planning_list',
  planning_show = 'planning_show',
  planning_submit = 'planning_submit',
  playback_schedule_create = 'playback_schedule_create',
  playback_schedule_delete = 'playback_schedule_delete',
  playback_schedule_edit = 'playback_schedule_edit',
  playback_schedule_list = 'playback_schedule_list',
  playback_schedule_show = 'playback_schedule_show',
  player_hardware_create = 'player_hardware_create',
  player_hardware_delete = 'player_hardware_delete',
  player_hardware_edit = 'player_hardware_edit',
  player_hardware_list = 'player_hardware_list',
  player_hardware_show = 'player_hardware_show',
  player_software_create = 'player_software_create',
  player_software_delete = 'player_software_delete',
  player_software_edit = 'player_software_edit',
  player_software_list = 'player_software_list',
  player_software_show = 'player_software_show',
  pm = 'pm',
  pool_change_order = 'pool_change_order',
  pool_create = 'pool_create',
  pool_delete = 'pool_delete',
  pool_edit = 'pool_edit',
  pool_list = 'pool_list',
  pool_show = 'pool_show',
  product_add_to_category = 'product_add_to_category',
  product_attribute_datatype_create = 'product_attribute_datatype_create',
  product_attribute_datatype_delete = 'product_attribute_datatype_delete',
  product_attribute_datatype_edit = 'product_attribute_datatype_edit',
  product_attribute_datatype_list = 'product_attribute_datatype_list',
  product_attribute_datatype_show = 'product_attribute_datatype_show',
  product_attributes_edit = 'product_attributes_edit',
  product_attributes_show = 'product_attributes_show',
  product_category_create = 'product_category_create',
  product_category_delete = 'product_category_delete',
  product_category_edit = 'product_category_edit',
  product_category_list = 'product_category_list',
  product_category_show = 'product_category_show',
  product_create = 'product_create',
  product_delete = 'product_delete',
  product_edit = 'product_edit',
  product_list = 'product_list',
  product_manage_category = 'product_manage_category',
  product_promoting_medium_group_add = 'product_promoting_medium_group_add',
  product_promoting_medium_group_manage = 'product_promoting_medium_group_manage',
  product_promoting_medium_group_remove = 'product_promoting_medium_group_remove',
  product_promoting_medium_group_show = 'product_promoting_medium_group_show',
  product_remove_from_category = 'product_remove_from_category',
  product_show = 'product_show',
  reporting_list = 'reporting_list',
  reporting_scheduling_list = 'reporting_scheduling_list',
  reporting_setup_create = 'reporting_setup_create',
  reporting_setup_delete = 'reporting_setup_delete',
  reporting_setup_edit = 'reporting_setup_edit',
  reporting_setup_list = 'reporting_setup_list',
  reporting_setup_show = 'reporting_setup_show',
  reporting_show = 'reporting_show',
  reporting_template_create = 'reporting_template_create',
  reporting_template_delete = 'reporting_template_delete',
  reporting_template_edit = 'reporting_template_edit',
  reporting_template_list = 'reporting_template_list',
  reporting_template_show = 'reporting_template_show',
  reporting_type_list = 'reporting_type_list',
  reporting_type_show = 'reporting_type_show',
  role_create = 'role_create',
  role_delete = 'role_delete',
  role_edit = 'role_edit',
  role_list = 'role_list',
  role_show = 'role_show',
  screen_booking_blacklist_create = 'screen_booking_blacklist_create',
  screen_booking_blacklist_delete = 'screen_booking_blacklist_delete',
  screen_booking_blacklist_list = 'screen_booking_blacklist_list',
  screen_hardware_create = 'screen_hardware_create',
  screen_hardware_delete = 'screen_hardware_delete',
  screen_hardware_edit = 'screen_hardware_edit',
  screen_hardware_list = 'screen_hardware_list',
  screen_hardware_show = 'screen_hardware_show',
  shared_asset_export = 'shared_asset_export',
  shared_asset_list = 'shared_asset_list',
  shared_asset_repository_export = 'shared_asset_repository_export',
  shared_asset_repository_list = 'shared_asset_repository_list',
  shared_asset_repository_show = 'shared_asset_repository_show',
  shared_asset_show = 'shared_asset_show',
  sr = 'sr',
  ss = 'ss',
  ss_cd = 'ss_cd',
  ss_cd_reporting = 'ss_cd_reporting',
  ss_fm = 'ss_fm',
  ss_fm_reporting = 'ss_fm_reporting',
  ss_nm = 'ss_nm',
  ss_nm_reporting = 'ss_nm_reporting',
  ssp_contract_create = 'ssp_contract_create',
  ssp_contract_delete = 'ssp_contract_delete',
  ssp_contract_edit = 'ssp_contract_edit',
  ssp_contract_list = 'ssp_contract_list',
  ssp_contract_show = 'ssp_contract_show',
  ssp_list = 'ssp_list',
  ssp_show = 'ssp_show',
  tag_connect = 'tag_connect',
  tag_connection_list = 'tag_connection_list',
  tag_create = 'tag_create',
  tag_delete = 'tag_delete',
  tag_disconnect = 'tag_disconnect',
  tag_edit = 'tag_edit',
  tag_list = 'tag_list',
  tag_show = 'tag_show',
  targeting_create = 'targeting_create',
  targeting_delete = 'targeting_delete',
  targeting_edit = 'targeting_edit',
  targeting_list = 'targeting_list',
  targeting_planning_create = 'targeting_planning_create',
  targeting_planning_edit = 'targeting_planning_edit',
  targeting_show = 'targeting_show',
  template_data_set_create = 'template_data_set_create',
  template_data_set_delete = 'template_data_set_delete',
  template_data_set_edit = 'template_data_set_edit',
  template_data_set_entry_create = 'template_data_set_entry_create',
  template_data_set_entry_delete = 'template_data_set_entry_delete',
  template_data_set_entry_edit = 'template_data_set_entry_edit',
  template_data_set_entry_list = 'template_data_set_entry_list',
  template_data_set_entry_render_medium = 'template_data_set_entry_render_medium',
  template_data_set_entry_show = 'template_data_set_entry_show',
  template_data_set_list = 'template_data_set_list',
  template_data_set_show = 'template_data_set_show',
  template_group_create = 'template_group_create',
  template_group_delete = 'template_group_delete',
  template_group_list = 'template_group_list',
  template_group_render_medium = 'template_group_render_medium',
  template_group_show = 'template_group_show',
  template_screen_entry_create = 'template_screen_entry_create',
  template_screen_entry_delete = 'template_screen_entry_delete',
  template_screen_entry_edit = 'template_screen_entry_edit',
  template_screen_entry_list = 'template_screen_entry_list',
  template_screen_entry_render_medium = 'template_screen_entry_render_medium',
  template_screen_entry_show = 'template_screen_entry_show',
  template_source_create = 'template_source_create',
  template_source_delete = 'template_source_delete',
  template_source_entry_create = 'template_source_entry_create',
  template_source_entry_delete = 'template_source_entry_delete',
  template_source_entry_edit = 'template_source_entry_edit',
  template_source_entry_list = 'template_source_entry_list',
  template_source_entry_render_medium = 'template_source_entry_render_medium',
  template_source_entry_show = 'template_source_entry_show',
  template_source_entry_subscription_create = 'template_source_entry_subscription_create',
  template_source_entry_subscription_delete = 'template_source_entry_subscription_delete',
  template_source_entry_subscription_edit = 'template_source_entry_subscription_edit',
  template_source_entry_subscription_list = 'template_source_entry_subscription_list',
  template_source_list = 'template_source_list',
  template_source_show = 'template_source_show',
  template_store_create = 'template_store_create',
  template_store_data_create = 'template_store_data_create',
  template_store_data_delete = 'template_store_data_delete',
  template_store_data_edit = 'template_store_data_edit',
  template_store_data_list = 'template_store_data_list',
  template_store_data_show = 'template_store_data_show',
  template_store_delete = 'template_store_delete',
  template_store_edit = 'template_store_edit',
  template_store_list = 'template_store_list',
  template_store_show = 'template_store_show',
  time_range_create = 'time_range_create',
  time_range_delete = 'time_range_delete',
  time_range_edit = 'time_range_edit',
  time_range_list = 'time_range_list',
  time_range_show = 'time_range_show',
  user_register = 'user_register',
  verification_list = 'verification_list',
  verification_reject = 'verification_reject',
  verification_show = 'verification_show',
  verification_verify = 'verification_verify',
  visitor_audience_translation_create = 'visitor_audience_translation_create',
  visitor_audience_translation_delete = 'visitor_audience_translation_delete',
  visitor_audience_translation_edit = 'visitor_audience_translation_edit',
  visitor_audience_translation_list = 'visitor_audience_translation_list',
  visitor_audience_translation_show = 'visitor_audience_translation_show',
  visitor_diurnal_cycle_create = 'visitor_diurnal_cycle_create',
  visitor_diurnal_cycle_delete = 'visitor_diurnal_cycle_delete',
  visitor_diurnal_cycle_edit = 'visitor_diurnal_cycle_edit',
  visitor_diurnal_cycle_list = 'visitor_diurnal_cycle_list',
  visitor_diurnal_cycle_show = 'visitor_diurnal_cycle_show',
  visitor_tracker_create = 'visitor_tracker_create',
  visitor_tracker_delete = 'visitor_tracker_delete',
  visitor_tracker_edit = 'visitor_tracker_edit',
  visitor_tracker_export = 'visitor_tracker_export',
  visitor_tracker_list = 'visitor_tracker_list',
  visitor_tracker_screen_assignment_list = 'visitor_tracker_screen_assignment_list',
  visitor_tracker_screen_assignment_modify = 'visitor_tracker_screen_assignment_modify',
  visitor_tracker_screen_assignment_show = 'visitor_tracker_screen_assignment_show',
  visitor_tracker_show = 'visitor_tracker_show',
  visitor_tracker_visitor_aggregation = 'visitor_tracker_visitor_aggregation',
  weekly_schedule_create = 'weekly_schedule_create',
  weekly_schedule_delete = 'weekly_schedule_delete',
  weekly_schedule_edit = 'weekly_schedule_edit',
  weekly_schedule_list = 'weekly_schedule_list',
  weekly_schedule_show = 'weekly_schedule_show',
}
